module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Menu', {
    ref: "sideMenu",
    staticClass: "left-menu",
    attrs: {
      "theme": _vm.theme,
      "activeName": _vm.currentMenu,
      "openNames": _vm.openNames,
      "width": "210px",
      "accordion": false
    },
    on: {
      "on-open-change": _vm.onOpenChange,
      "on-select": _vm.onSelect
    }
  }, [_vm._l((_vm.menuGroups), function(menuGroup) {
    return [(menuGroup.hasPermission) ? [(!menuGroup.url) ? _c('Submenu', {
      attrs: {
        "name": menuGroup.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(menuGroup.icon) ? _c('Icon', {
      attrs: {
        "type": menuGroup.icon
      }
    }) : _vm._e(), _vm._v("\n          " + _vm._s(menuGroup.name) + "\n        ")], 1), _vm._v(" "), _vm._l((menuGroup.menuItems), function(menuItem) {
      return [(menuItem.hasPermission && menuItem.subItems) ? _c('Submenu', {
        key: 'sub-' + menuItem.name,
        attrs: {
          "name": menuItem.name
        }
      }, [_c('template', {
        slot: "title"
      }, [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _vm._l((menuItem.subItems), function(child) {
        return (child.hasPermission) ? _c('Menu-item', {
          key: child.name,
          attrs: {
            "name": child.name
          }
        }, [_vm._v("\n              " + _vm._s(child.name)), (_vm.hrBadgeCount(child)) ? _c('span', {
          staticClass: "hr-menu-badge"
        }, [_vm._v(_vm._s(_vm.hrBadgeCount(child)))]) : _vm._e()]) : _vm._e()
      })], 2) : (menuItem.hasPermission) ? _c('Menu-item', {
        key: menuItem.name,
        attrs: {
          "name": menuItem.name
        }
      }, [_vm._v("\n            " + _vm._s(menuItem.name)), (_vm.hrBadgeCount(menuItem)) ? _c('span', {
        staticClass: "hr-menu-badge"
      }, [_vm._v(_vm._s(_vm.hrBadgeCount(menuItem)))]) : _vm._e()]) : _vm._e()]
    })], 2) : _c('Menu-item', {
      attrs: {
        "name": menuGroup.name
      }
    }, [_vm._v("\n        " + _vm._s(menuGroup.name) + "\n      ")])] : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2e11e50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LeftMenu.vue
// module id = 1990
// module chunks = 8